export class GetOccasionAction {
  static type = '[OCCASION] Get occasions';
}
